export const OPEN_EXAMPLES = 'OPEN_EXAMPLES';
export const CHANGE_EXAMPLE_INDEX = 'CHANGE_EXAMPLE_INDEX';
export const IMPORT_EXAMPLE = 'IMPORT_EXAMPLE';
export const VIEW_EXAMPLE = 'VIEW_EXAMPLE';
export const CLOSE_EXAMPLE = 'CLOSE_EXAMPLE';
export const NEXT_EXAMPLE = 'NEXT_EXAMPLE';
export const PREV_EXAMPLE = 'PREV_EXAMPLE';
export const CHANGE_SEARCH = 'CHANGE_SEARCH';